import React, { Fragment } from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faTruck } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import { groupBy, farmatearMontos } from '../../../../Util/Util';
import TimeLabel from '../../../../UI/TimeLabel/TimeLabel';

const gridOrdenes = props => {
    let columnas = null;
    if (props.tipo === '1') {
        columnas = [
            { nombre: 'Orden', ancho: 2, class: '' },
            { nombre: 'Sucursal Factura', ancho: 2, class: '' },
            { nombre: 'Ubicación', ancho: 2, class: '' },
            { nombre: 'Cliente', ancho: 2, class: '' },
            { nombre: 'Total', ancho: 1, class: 'text-center' },
            { nombre: 'Fecha/Hora', ancho: 1, class: 'text-center' },
            { nombre: 'Subórdenes', ancho: 1, class: 'text-center' },
            { nombre: 'Tiempo/Estado', ancho: 1, class: 'text-right' }
        ];
    }
    else {
        columnas = [
            { nombre: 'Orden', ancho: 2, class: '' },
            { nombre: 'Sucursal Factura', ancho: 2, class: '' },
            { nombre: 'Ubicación', ancho: 2, class: '' },
            { nombre: 'Cliente', ancho: 2, class: '' },
            { nombre: 'Total', ancho: 1, class: 'text-center' },
            { nombre: 'Salida', ancho: 1, class: 'text-center' },
            { nombre: 'Subórdenes', ancho: 1, class: 'text-center' },
            { nombre: 'Tiempo/Estado', ancho: 1, class: 'text-right' }
        ];
    }

    const ordenes = groupBy(props.ordenes, orden => moment(orden.Fecha_Activar).isSameOrBefore(moment.utc(), 'hour') ? 'current' : 'future');

    const currentRows = ordenes && ordenes.current && ordenes.current.length > 0 ? ordenes.current.map(orden => {
        let estatus = props.estatus ? props.estatus.filter((e) => e.Eco_Venta_Id === orden.Eco_Venta_Id && e.Orden_Grupo === orden.Orden_Grupo)[0] : null;
        const keyLink = `${orden.Orden_Ecommerce ? 'EC' : 'EX'}${orden.Orden_Grupo}`;

        return (
            props.estadoOrdenes === '2' || props.estadoOrdenes === '3' || estatus && (estatus.Estado === props.estatusFiltro || props.estatusFiltro === '') ?
                <Link to={{ pathname: props.linkDetalle, state: { esEcommerce: orden.Orden_Ecommerce, ordenId: orden.Orden_Grupo, total: orden.Total, tab: props.estadoOrdenes } }} key={keyLink} className="monitor-sucursal-row">
                    <div className="row th">
                        <div className={`col-${columnas[0].ancho} ${columnas[0].class}`}>
                            <p>{`Exp: ${orden.Orden_Id}${orden.Orden_Ecommerce ? ` - Eco: ${orden.Eco_Venta_Id}` : ''}`}</p>
                            <span className="icon-entrega">
                                {
                                    orden.Orden_Tipo_Entrega === "Tienda" ?
                                        <FontAwesomeIcon icon={faStore} /> :
                                        <FontAwesomeIcon icon={faTruck} />
                                }
                                <p>{orden.Orden_Tipo_Entrega}</p>
                            </span>
                        </div>
                        <div className={`col-${columnas[1].ancho} ${columnas[1].class}`}>
                            <p>{orden.Orden_Suc_Factura_Nombre}</p>
                        </div>
                        <div className={`col-${columnas[2].ancho} ${columnas[2].class}`}>
                            <p>{orden.Ubicacion_Id}</p>
                        </div>
                        <div className={`col-${columnas[3].ancho} ${columnas[3].class}`}>
                            <p>{orden.Cliente_Nombre}</p>
                        </div>
                        <div className={`col-${columnas[4].ancho} ${columnas[4].class}`}>
                            <p>{farmatearMontos((orden.Total ? orden.Total : 0))}</p>
                            <p>Items({orden.Items})</p>
                        </div>
                        <div className={`col-${columnas[5].ancho} ${columnas[5].class}`}>
                            <p><Moment format="DD/MM/YYYY hh:mm A" date={orden.Fecha_Registro}></Moment></p>
                        </div>
                        <div className={`col-${columnas[6].ancho} ${columnas[6].class}`}>
                            <p className="text-center">{orden.Orden_Num_SubOrdenes}</p>
                        </div>
                        <div className={`col-${columnas[7].ancho} ${columnas[7].class}`}>
                            {
                                estatus ?
                                    <TimeLabel tiempo={estatus.Tiempo_Actual} estado={estatus.Estado} activo={props.tiempoActivo} ></TimeLabel>
                                    : null
                            }
                            <p>{orden.Estatus_Nombre}</p>
                        </div>
                    </div>
                </Link>
                : null
        )
    }) : null;

    let lastFutureDate = null;
    let hour = -1;
    const futureRows = (props.estatusFiltro === 'success' || props.estatusFiltro === '') && ordenes && ordenes.future && ordenes.future.length > 0 ? ordenes.future.map(orden => {
        const keyLink = `${orden.Orden_Ecommerce ? 'EC' : 'EX'}${orden.Orden_Grupo}`;
        const activeHour = moment.utc(orden.Fecha_Activar).hours();
        const activeDate = moment.utc(orden.Fecha_Activar).startOf('day');

        let separador = null;
        if (hour === -1 || hour !== activeHour) {
            separador = <div className="row">
                <div className="col">
                    {!lastFutureDate || activeDate > lastFutureDate ?
                        <div className="row">
                            <div className="col-auto grupo-ordenes-dia"><span style={{ textTransform: 'capitalize' }}>{`${moment(orden.Fecha_Activar).locale("es").format("dddd")} ${moment(orden.Fecha_Activar).format('DD/MM/yyyy')}`}</span></div>
                            <div className="col grupo-ordenes-dia-linea"></div>
                        </div> : null}
                    <div className="grupo-ordenes-2">{moment.utc(orden.Fecha_Activar).format('h A')}</div>
                </div>
            </div>;
            hour = activeHour;
        }
        lastFutureDate = activeDate;

        return <Fragment>
            {
                separador
            }
            <Link to={{ pathname: props.linkDetalle, state: { esEcommerce: orden.Orden_Ecommerce, ordenId: orden.Orden_Grupo, total: orden.Total } }} key={keyLink} className="monitor-sucursal-row">
                <div className="row th">
                    <div className={`col-${columnas[0].ancho} ${columnas[0].class}`}>
                        <p>{`Exp: ${orden.Orden_Id}${orden.Orden_Ecommerce ? ` - Eco: ${orden.Eco_Venta_Id}` : ''}`}</p>
                        <span className="icon-entrega">
                            {
                                orden.Orden_Tipo_Entrega === "Tienda" ?
                                    <FontAwesomeIcon icon={faStore} /> :
                                    <FontAwesomeIcon icon={faTruck} />
                            }
                            <p>{orden.Orden_Tipo_Entrega}</p>
                        </span>
                    </div>
                    <div className={`col-${columnas[1].ancho} ${columnas[1].class}`}>
                        <p>{orden.Orden_Suc_Factura_Nombre}</p>
                    </div>
                    <div className={`col-${columnas[2].ancho} ${columnas[2].class}`}>
                        <p>{orden.Ubicacion_Id}</p>
                    </div>
                    <div className={`col-${columnas[3].ancho} ${columnas[3].class}`}>
                        <p>{orden.Cliente_Nombre}</p>
                    </div>
                    <div className={`col-${columnas[4].ancho} ${columnas[4].class}`}>
                        <p>{farmatearMontos((orden.Total ? orden.Total : 0))}</p>
                        <p>Items({orden.Items})</p>
                    </div>
                    <div className={`col-${columnas[5].ancho} ${columnas[5].class}`}>
                        <p className="text-center"><Moment format="DD/MM/YYYY hh:mm A" date={orden.Fecha_Registro}></Moment></p>
                    </div>
                    <div className={`col-${columnas[6].ancho} ${columnas[6].class}`}>
                        <p className="text-center">{orden.Orden_Num_SubOrdenes}</p>
                    </div>
                    <div className={`col-${columnas[7].ancho} ${columnas[7].class}`}>
                        <TimeLabel tiempo={0} estado={'success'} activo={false} ></TimeLabel>
                        <p>{orden.Estatus_Nombre}</p>
                    </div>
                </div>
            </Link>
        </Fragment>

    }) : null;

    return (
        <div className="table-monitor">
            <div className="row th grid-ordenes-header">
                {
                    columnas.map((columna, index) => {
                        return (<div className={`col-${columna.ancho} ${columna.class}`} key={index}>{columna.nombre}</div>)
                    })
                }
            </div>
            {
                currentRows && props.estadoOrdenes === '0' ?
                    <div className="row">
                        <div className="col">
                            <div className="grupo-ordenes-2">Órdenes Activas</div>
                        </div>
                    </div>
                    : null
            }
            {currentRows}
            {futureRows}
        </div>
    )
};

export default gridOrdenes;